export const SESSION_COOKIE_KEY = "bimi";

export const DELIVERY_TOKEN_HEADER_KEY = "X-API-KEY";
export const AUTH_HEADER_TOKEN = "Authorization";

//Getters
export const GET_SESSION_TOKEN = "getSessionToken";
export const GET_IS_LOGGED_IN = "getIsLoggedIn";
export const GET_HTTP_CONFIG = "getHttpConfig";
export const GET_BACKEND_URL = "getBackendUrl";
export const GET_FRONTEND_URL = "getFrontendUrl";
export const GET_CURRENT_ROUTE = "getCurrentRoute";
export const GET_CURRENT_QUESTION_NAME = "getCurrentQuestionName";
export const GET_IS_SIGNUP_PROCESS_LOADING = "getIsSignupProcessLoading";
export const GET_IDEA_COACH_STATE = "getIdeaCoachState";
export const GET_IS_CURRENT_ROUTE_PART_OF_EDIT_GROUP = "getIsCurrentRoutePartOfEditGroup";
export const GET_DOES_STUDY_NEED_TO_BE_LOADED = "getDoesStudyNeedToBeLoaded";
export const GET_NEXT_STUDY_STEP_ROUTE = "getNextStudyStepRoute";
export const GET_PREVIOUS_STUDY_STEP_ROUTE = "getPreviousStudyStepRoute";
export const GET_IN_PROGRESS_STUDY_NAME = "getInProgressStudyName";
export const GET_IN_PROGRESS_STUDY_LANGUAGE = "getInProgressStudyLanguage";
export const GET_IN_PROGRESS_STUDY_MODEL = "getInProgressStudyModel";
export const GET_IN_PROGRESS_STUDY_NUMBER_OF_ANSWERS = "getInProgressStudyNumberOfAnswers";
export const GET_IN_PROGRESS_STUDY_ANSWERS_AMOUNT = "getInProgressStudyAnswersAmount";
export const GET_IN_PROGRESS_STUDY_NUMBER_OF_QUESTIONS = "getInProgressStudyNumberOfQuestions";
export const GET_IN_PROGRESS_STUDY_QUESTIONS_AMOUNT = "getInProgressStudyQuestionsAmount";
export const GET_IN_PROGRESS_STUDY_QUESTIONS = "getInProgressStudyQuestions";
export const GET_IN_PROGRESS_STUDY_CURRENT_QUESTION_OBJ = "getInProgressStudyCurrentQuestionObj";
export const GET_IN_PROGRESS_STUDY_CURRENT_QUESTION_INDEX =
  "getInProgressStudyCurrentQuestionIndex";
export const GET_IN_PROGRESS_STUDY_CURRENT_QUESTION_INDEX_ENGLISH =
  "getInProgressStudyCurrentQuestionIndexEnglish";
export const GET_IN_PROGRESS_STUDY_NUMBER_OF_SEGMENT_QUESTIONS =
  "getInProgressStudyNumberOfSegmentQuestions";
export const GET_IN_PROGRESS_STUDY_ADDITIONAL_CLASSIFICATION_QUESTION_OBJ =
  "getInProgressStudyAdditionalClassificationQuestionObj";
export const GET_IN_PROGRESS_STUDY_OPEN_ENDED_QUESTION = "getInProgressStudyOpenEndedQuestion";
export const GET_IN_PROGRESS_STUDY_PRE_OPTIONAL_QUESTION = "getInProgressStudyPreOptionalQuestion";
export const GET_IN_PROGRESS_STUDY_RESPONDENT_ORIENTATION =
  "getInProgressStudyRespondentOrientation";
export const GET_IN_PROGRESS_STUDY_RATING_SCALE_NUMBER_OPTIONS =
  "getInProgressStudyRatingScaleNumberOptions";
export const GET_IS_IN_PROGRESS_STUDY_UPDATING = "getIsInProgressStudyUpdating";
export const GET_IS_MOBILE_VIEWPORT = "getIsMobileViewport";
export const GET_NAV_ROUTES = "getNavRoutes";
export const GET_COPYRIGHT_TEXT = "getCopyrightText";
export const GET_PROFILE_DROPDOWN_TEXT = "getProfileDropdownText";
export const GET_STUDIES_OF_USER = "getStudiesOfUser";
export const GET_PURCHASES_OF_USER = "getPurchasesOfUser";
export const GET_OUTGOING_STUDY_OBJ = "getOutgoingStudyObject";
export const GET_STRIPE_STANDARD_KEY = "getStripeStandardKey";
export const GET_STRIPE_LUCID_KEY = "getStripeLucidKey";
export const GET_STRIPE_OBJ = "getStripeObj";
export const GET_CURRENT_STUDY_EXCEL_URL = "getCurrentStudyExcelUrl";
export const GET_CURRENT_STUDY_EXCEL_URL_FLASH = "getCurrentStudyExcelUrlFlash";
export const GET_CURRENT_STUDY_POWERPOINT_URL = "getCurrentStudyPowerpointUrl";
export const GET_CURRENT_STUDY_IDEABOOK_URL = "getCurrentStudyIdeabookUrl";
export const GET_SURVEY = "getSurvey";
export const GET_SURVEY_PREVIEW = "getSurveyPreview";
export const IS_SURVEY_RTL = "isSurveyRtl";
export const GET_IN_PROGRESS_PRESENTATION_MEDIA = "getInProgressPresentationMedia";
export const GET_IN_PROGRESS_POST_PRESENTATION_MEDIA = "getInProgressPostPresentationMedia";

//Mutations
export const SET_SESSION = "setSession";
export const SET_SIGNUP_STATE = "setSignupState";
export const SET_USER = "setUser";
export const SET_COUNTRIES = "setCountries";
export const SET_SURVEY = "setSurvey";
export const SET_SURVEY_PREVIEW = "setSurveyPreview";
export const SET_USER_POSITION_IN_SURVEY = "setUserPositionInSurvey";
export const SET_CATEGORIES_STATE = "setCategoriesState";
export const SET_UPDATE_STUDY_STATE = "setUpdateStudyState";
export const SET_GET_STUDY_STATE = "setGetStudyState";
export const SET_DELETE_STUDY_STATE = "setDeleteStudyState";
export const SET_STUDY_RESULTS = "setStudyResults";
export const SET_STUDY_RESULTS_AGE_STATE = "setStudyResultsAgeState";
export const SET_STUDY_RESULTS_GENDER_STATE = "setStudyResultsGenderState";
export const SET_STUDY_RESULTS_PRELIM_STATE = "setStudyResultsPrelimState";
export const SET_STUDY_RESULTS_2_MARKET_SEGMENT_STATE = "setStudyResults2MarketSegmentState";
export const SET_STUDY_RESULTS_3_MARKET_SEGMENT_STATE = "setStudyResults3MarketSegmentState";
export const SET_STUDY_RESULTS_OVERALL_WORDS = "setStudyResultsOverallWords";
export const SET_STUDY_RESULTS_AGE_WORDS_STATE = "setStudyResultsAgeWordsState";
export const SET_STUDY_RESULTS_GENDER_WORDS_STATE = "setStudyResultsGenderWordsState";
export const SET_STUDY_RESULTS_PRELIM_WORDS_STATE = "setStudyResultsPrelimWordsState";
export const SET_STUDY_RESULTS_2_MARKET_SEGMENT_WORDS_STATE =
  "setStudyResults2MarketSegmentWordsState";
export const SET_STUDY_RESULTS_3_MARKET_SEGMENT_WORDS_STATE =
  "setStudyResults3MarketSegmentWordsState";
export const SET_IN_PROGRESS_STUDY_ASKS_LINKER = "setInProgressStudyAsksLinker";
export const SET_ALL_SECONDARY_STUDY_RESULTS_STATE = "setAllSecondaryStudyResultsState";
export const SET_EMAIL_CONFIRMATION_STATE = "setEmailConfirmationState";
export const SET_EMAIL_RESEND_STATE = "setEmailResentState";
export const SET_STUDIES_OF_USER = "setStudiesOfUser";
export const SET_PURCHASES_OF_USER = "setPurchasesOfUser";
export const SET_CURRENT_ROUTE = "setCurrentRoute";
export const SET_IN_PROGRESS_STUDY_NAME = "setInProgressStudyName";
export const SET_IN_PROGRESS_STUDY_LANGUAGE = "setInProgressStudyLanguage";
export const SET_IN_PROGRESS_STUDY_AGREED_TO_TERMS = "setInProgressStudyAgreedToTerms";
export const SET_IN_PROGRESS_STUDY_MODE = "setInProgressStudyMode";
export const SET_IN_PROGRESS_STUDY_MODEL = "setInProgressStudyModel";
export const SET_IN_PROGRESS_STUDY_ANSWERS_OF_QUESTION_N = "setInProgressStudyAnswersOfQuestionN";
export const SET_IN_PROGRESS_STUDY_QUESTIONS_TEXT = "setInProgressStudyQuestionsText";
export const SET_IN_PROGRESS_STUDY_REJECT_RESPONDENT_ID_QUESTION =
  "setInProgressStudyRejectRespondentIdQuestion";
export const SET_IN_PROGRESS_STUDY_OPEN_ENDED_QUESTION = "setInProgressStudyOpenEndedQuestion";
export const SET_IN_PROGRESS_STUDY_PRE_OPTIONAL_QUESTION = "setInProgressStudyPreOptionalQuestion";
export const SET_IN_PROGRESS_STUDY_RESPONDENT_ORIENTATION =
  "setInProgressStudyRespondentOrientation";
export const SET_IN_PROGRESS_STUDY_RATING_SCALE_OBJ = "setInProgressStudyRatingScaleObj";
export const SET_IN_PROGRESS_STUDY_FINAL_THOUGHTS = "setInProgressStudyFinalThoughts";
export const SET_IN_PROGRESS_STUDY_STUDENT = "setInProgressStudyStudent";
export const SET_TELL_US_WHO_YOU_ARE = "setTellUsWhoYouAre";
export const PUSH_IN_PROGRESS_STUDY_KEYWORD = "pushInProgressStudyKeyword";
export const PUSH_IN_PROGRESS_STUDY_SEGMENT_QUESTION = "pushInProgressSegmentQuestion";
export const REPLACE_IN_PROGRESS_STUDY_SEGMENT_QUESTION_AT_INDEX =
  "replaceInProgressSegmentQuestionAtIndex";
export const DELETE_IN_PROGRESS_STUDY_SEGMENT_QUESTION_AT_INDEX =
  "deleteInProgressSegmentQuestionAtIndex";
export const SPLICE_IN_PROGRESS_STUDY_KEYWORD = "spliceInProgressStudyKeyword";
export const SET_IN_PROGRESS_STUDY_SERVICE_TYPE = "setInProgressStudyServiceType";
export const SET_IN_PROGRESS_STUDY_AGREED_TO_TERMS_FINAL = "setInProgressStudyAgreedToTermsFinal";
export const SET_STUDY_SOURCING_METHOD = "setStudySourcingMethod";
export const SET_STUDY_PRIVATE = "setStudyPrivate";
export const SET_STUDY_MAX_PARTICIPANTS = "setStudyMaxParticipants";
export const SET_STUDY_PUBLISHED = "setStudyPublished";
export const SET_SURVEY_QUALIFICATIONS = "setSurveyQualifications";
export const RESET_SURVEY_QUALIFICATIONS = "resetSurveyQualifications";
export const SET_SURVEY_SELECTED_QUALIFICATIONS = "setSurveySelectedQualifications";
export const SET_SURVEY_UPDATE_SELECTED_QUALIFICATIONS_STATE =
  "setSurveyUpdateSelectedQualificationsState";
export const SET_RESET_SELECTED_QUALIFICATIONS = "setResetSelectedQualifications";
export const SET_LOGIN_DROPDOWN_STATE = "setLoginDropdownState";
export const SET_RESET_PASSWORD_SHOW_STATE = "setResetPasswordShowState";
export const SET_RESET_PASSWORD_STATE = "setResetPasswordState";
export const SET_PUBLIC_STUDY_INFO = "setPublicStudyInfo";
export const SET_LOGIN_REDIRECT = "setLoginRedirect";
export const RESET_LOGIN_REDIRECT = "resetLoginRedirect";
export const SET_VIEWPORT_OBJECT = "setViewportObject";
export const SET_STRIPE_OBJECT = "setStripeObject";
export const SET_STRIPE_SCRIPT_TAG_STATE = "setStripeScriptTagState";
export const SET_PRIVATE_STUDY_PAYMENT_STATE = "setPrivateStudyPaymentState";
export const SET_PRIVATE_PAYMENT_POST_TO_BACKEND_STATE = "setPrivatePaymentPostToBackendState";
export const SET_PUBLIC_STUDY_PAYMENT_STATE = "setPublicStudyPaymentState";
export const SET_PUBLIC_PAYMENT_POST_TO_BACKEND_STATE = "setPublicPaymentPostToBackendState";
export const RESET_PUBLIC_STUDY_PAYMENT = "resetPublicStudyPayment";
export const RESET_PUBLIC_PAYMENT_POST_TO_BACKEND = "resetPublicPaymentPostToBackend";
export const SET_REDIRECT_URL = "setRedirectURL";
export const SET_CHECKOUT_SCRIPT_TAG_STATE = "setCheckoutScriptTagState";
export const SET_CHECKOUT_OBJECT = "setCheckoutObject";
export const SET_I18N = "setI18n";
export const SET_I18N_LANGUAGE = "setI18nLanguage";
export const SET_IN_PROGRESS_PRESENTATION_MEDIA = "setInProgressPresentationMedia";
export const SET_IN_PROGRESS_POST_PRESENTATION_MEDIA = "setInProgressPostPresentationMedia";
export const SET_IDEA_COACH_STATE = "setIdeaCoachState";

// Actions
export const PRE_INIT_STORE = "preInitStore";
export const INIT_STORE = "initStore";
export const INIT_AUTHENTICATED_STORE = "initAuthenticatedStore";
export const INIT_DATA_MODULE = "initDataModule";
export const INIT_PAYMENT_MODULE = "initPaymentModule";
export const INIT_USER_MODULE = "initUserModule";
export const INIT_AUTHENTICATED_USER_MODULE = "initAuthenticatedUserModule";
export const LOAD_USER = "loadUser";
export const UPDATE_USER = "updateUser";
export const LOAD_SESSION_FROM_COOKIE = "loadSessionFromCookie";
export const LOGIN = "login";
export const SIGNUP = "signup";
export const LOGOUT = "logout";
export const LOAD_UI_TEXT = "loadUIText";
export const LOAD_BODY_TEXT = "loadBodyText";
export const A_PER_ROUTE_ACTIONS = "actionPerRouteActions";
export const A_DATA_MODULE_PER_ROUTE_ACTIONS = "actionDataModulePerRouteActions";
export const A_STORE_RESULTS_MODULE_PER_ROUTE_ACTIONS = "actionStoreResultsModulePerRouteActions";
export const A_ROUTER_MODULE_PER_ROUTE_ACTIONS = "actionRouterModulePerRouteActions";
export const LOAD_STUDIES_OF_USER = "loadStudiesOfUser";
export const LOAD_PURCHASES_OF_USER = "loadPurchasesOfUser";
export const UPDATE_STUDY = "updateStudy";
export const GET_STUDY = "getStudy";
export const DELETE_STUDY = "deleteStudy";
export const LOAD_STUDY_RESULTS = "loadStudyResults";
export const LOAD_STRIPE = "loadStripe";
export const LOAD_CHECKOUT = "loadCheckout";
export const INSTANTIATE_STRIPE = "instantiateStripe";
export const INSTANTIATE_STRIPE_LUCID = "instantiateLucidStripe";
export const INSTANTIATE_CHECKOUT = "instantiateCheckout";
export const PROCESS_PRIVATE_STUDY_PAYMENT = "processPrivateStudyPayment";
export const PROCESS_PUBLIC_STUDY_PAYMENT = "processPublicStudyPayment";
export const SEND_PAYMENT_INFO_TO_BACKEND = "sendPaymentToBackend";
export const SEND_LUCID_PURCHASE_ITEM_TO_BACKEND = "sendLucidPurchaseItemToBackend";
export const SEND_LUCID_OBJECT_TO_BACKEND = "sendLucidObjectToBackend";
export const SEND_LUCID_OBJECT_TO_BACKEND_UPDATE = "sendLucidObjectToBackendUpdate";
export const LOAD_SURVEY_QUALIFICATIONS = "loadSurveyQualifications";
export const UPDATE_SURVEY_SELECTED_QUALIFICATIONS = "updateSurveySelectedQualifications";
export const LOAD_COUNTRIES = "loadCountries";
export const LOAD_PUBLIC_STUDY_INFO = "loadPublicStudyInfo";
export const LOAD_STUDY_RESULTS_AGE = "loadStudyResultsAge";
export const LOAD_STUDY_RESULTS_GENDER = "loadStudyResultsGender";
export const LOAD_STUDY_RESULTS_PRELIM = "loadStudyResultsPrelim";
export const LOAD_STUDY_RESULTS_2_MARKET_SEGMENT = "loadStudyResults2MarketSegment";
export const LOAD_STUDY_RESULTS_3_MARKET_SEGMENT = "loadStudyResults3MarketSegment";
export const LOAD_STUDY_RESULTS_OVERALL_WORDS = "loadStudyResultsOverallWords";
export const LOAD_STUDY_RESULTS_AGE_WORDS_STATE = "loadStudyResultsAgeWords";
export const LOAD_STUDY_RESULTS_GENDER_WORDS_STATE = "loadStudyResultsGenderWords";
export const LOAD_STUDY_RESULTS_PRELIM_WORDS_STATE = "loadStudyResultsPrelimWords";
export const LOAD_STUDY_RESULTS_2_MARKET_SEGMENT_WORDS_STATE =
  "loadStudyResults2MarketSegmentWords";
export const LOAD_STUDY_RESULTS_3_MARKET_SEGMENT_WORDS_STATE =
  "loadStudyResults3MarketSegmentWords";
export const USER_POSITION_IN_SURVEY = "userPositionInSurvey";
export const RESET_SELECTED_QUALIFICATIONS = "resetSelectedQualifications";
export const RESEND_CONFIRMATION_EMAIL = "resendConfirmationEmail";
export const LOAD_ALL_STUDY_RESULTS_DATA = "loadAllStudyResultsData";
export const COMPLETE_SURVEY = "completeSurvey";
export const RESET_PASSWORD = "resetPassword";
export const A_UPDATE_IDEA_COACH_STATE = "updateIdeaCoachState";
export const A_RESET_IDEA_COACH_STATE = "resetIdeaCoachState";

// Loading States
export const LOADING_PRISTINE = 0;
export const LOADING_STARTED = 1;
export const LOADING_COMPLETED_SUCCESS = 2;
export const LOADING_COMPLETED_FAILURE = 3;

// Survey States
export const SURVEY_CLOSED = "closed";
export const SURVEY_COMPLETED = "completed";
export const SURVEY_MISSING = "missing";
export const SURVEY_OPEN = "open";

// Button modes
export const BUTTON_MODE_DEFAULT = 0;
export const BUTTON_MODE_DOWNLOAD_BANNER = 1;

// Radio button values
export const RADIO_BUTTON_VALUE_STANDARD_SERVICE = "standard";

//Route Names
export const R_NAME_CREATE_A_STUDY = "createAStudy";
export const R_NAME_CREATE_STUDY_LOADING = "createStudyLoading";
export const R_NAME_CREATE_STUDY_CHOOSE_NUMBER_OF_QUESTIONS = "createStudyChooseNumberOfQuestions";
export const R_NAME_CREATE_STUDY_QUESTIONS = "createStudyQuestions";
export const R_NAME_CREATE_STUDY_ANSWERS_OF_QUESTION_N = "createStudyAnswersOfQuestionN";
export const R_NAME_CREATE_STUDY_SEGMENT_QUESTION_N = "createStudySegmentQuestionN";
export const R_NAME_CREATE_STUDY_OPEN_ENDED_QUESTION = "createStudyOpenEndedQuestion";
export const R_NAME_CREATE_STUDY_PRE_OPTIONAL_QUESTION = "createStudyPreOptionalQuestion";
export const R_NAME_CREATE_STUDY_RESPONDENT_ORIENTATION = "createStudyRespondentOrientation";
export const R_NAME_CREATE_STUDY_RATING_SCALE = "createStudyRatingScale";
export const R_NAME_CREATE_STUDY_FINAL_THOUGHTS = "createStudyFinalThoughts";
export const R_NAME_CREATE_STUDY_TELL_US_WHO_YOU_ARE = "createStudyTellUsWhoYouAre";
export const R_NAME_CREATE_STUDY_DONE = "createStudyDone";
export const R_NAME_MANAGE_STUDY_CHOOSE_SOURCING_METHOD = "manageStudyChooseSourcingMethod";
export const R_NAME_HOME = "home";
export const R_NAME_ABOUT = "about";
export const R_NAME_CONTACT = "contact";
export const R_NAME_PRIVACY = "privacy";
export const R_NAME_TERMS_OF_SERVICE = "termsOfService";
export const R_NAME_BROWSE = "browse";
export const R_NAME_DASHBOARD = "dashboard";
export const R_NAME_RESULTS = "results";
export const R_NAME_PURCHASE = "purchase";
export const R_NAME_PURCHASE_FLASH = "purchaseFlash";
export const R_NAME_MANAGE_PARTICIPANTS = "manageParticipants";
export const R_NAME_SIGN_UP = "signup";
export const R_NAME_MY_PROFILE = "myProfile";
export const R_NAME_SURVEY = "survey";
export const R_NAME_PUBLIC_SURVEY = "publicSurvey";
export const R_NAME_SURVEY_PREVIEW = "surveyPreview";
export const R_NAME_PUBLIC_STUDY = "publicStudy";
export const R_NAME_RAW_DATA = "rawData";
export const R_NAME_BUY_STUDY = "buyStudy";
export const R_NAME_FLASH_RESULTS = "flashResults";
export const R_NAME_CONFIRMATION_PAGE = "confirmationPage";
export const R_NAME_PASSWORD_RESET_PAGE = "passwordResetPage";
export const R_NAME_MANAGE_STUDY_SURVEY_QUALIFICATIONS_LANGUAGE =
  "manageStudySurveyQualificationsLanguage";
export const R_NAME_MANAGE_STUDY_SURVEY_QUALIFICATIONS_QUESTION =
  "manageStudySurveyQualificationsQuestion";
export const R_NAME_MANAGE_STUDY_SURVEY_QUALIFICATIONS_AGE = "manageStudySurveyQualificationsAge";
export const R_NAME_MANAGE_STUDY_SURVEY_QUALIFICATIONS_PAYMENT =
  "manageStudySurveyQualificationsPayment";
export const R_NAME_PUBLIC_STUDY_INFO = "publicStudyInfo";
export const R_NAME_PURCHASES = "purchases";
export const R_NAME_CREATE_STUDY_PRESENTATION_MEDIA = "presentationMedia";
export const R_NAME_CREATE_STUDY_POST_PRESENTATION_MEDIA = "postPresentationMedia";

// Viewport labels
export const VIEWPORT_LABEL_MOBILE = "mobile";

// Repeated static text
export const STATIC_TEXT_PLUG_1 =
  "The goal of BimiLeap is to create learning opportunities for all - and to contribute to the marketplace of ideas by providing quality research opportunities for anyone who has an idea to test and a desire to learn.";

// Study mode
export const STUDY_MODE_4 = "4x4";
export const STUDY_MODE_6 = "6x6";
export const FOUR_X_FOUR_MAX_NUMBER_SEGMENT_QUESTIONS = 1;
export const SIX_X_SIX_MAX_NUMBER_SEGMENT_QUESTIONS = 20;
export const STUDY_SOURCE_SELECTION_SELF = "self";
export const STUDY_SOURCE_SELECTION_LUCID = "lucid";
export const STUDY_SOURCE_SELECTION_CUSTOM = "custom";
export const STUDY_SOURCE_SELECTION_EXTERNAL = "external";
export const STUDY_SOURCE_SELECTION_DEMO = "demo";
export const STUDY_SOURCE_SELECTION_ACADEMIC = "academic";

export const LEARN_MORE_DIALOG_MODE_PUBLIC = "public";
export const LEARN_MORE_DIALOG_MODE_PRIVATE = "private";

export const SURVEY_QUALIFICATION_TYPE_NUMERIC_OPEN_ENDED = "Numeric - Open-end";
export const SURVEY_QUALIFICATION_NAME_AGE = "Age";

// Class names
export const CSS_CLASS_NAME_INVALID = "invalid";
export const CSS_CLASS_NAME_DATEPICKER_INPUT = "bigmi-datepicker-input-wrapper";
export const CSS_CLASS_NAME_SELECTED_TAB = "selected-tab";
export const CSS_CLASS_NAME_RESULTS_QUESTION_ROW_CELL = "question-row-cell";
export const CSS_CLASS_NAME_RESULTS_QUESTION_SCORE = "question-score";

// Genders
export const GENDER_MALE = "male";
export const GENDER_FEMALE = "female";

// Date formats
export const DATE_FORMAT_DATEPICKER = "MMM dd, yyyy";

export const EVENT_NAME_INPUT = "input";
export const EVENT_NAME_SUBMIT = "submit";
export const EVENT_NAME_CANCEL = "cancel";

export const IDEA_COACH_TYPE = {
  question: "question",
  answer: "answer",
};
